/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
const inlineSuggestCommitId = 'editor.action.inlineSuggest.commit';
const showPreviousInlineSuggestionActionId = 'editor.action.inlineSuggest.showPrevious';
const showNextInlineSuggestionActionId = 'editor.action.inlineSuggest.showNext';
const jumpToNextInlineEditId = 'editor.action.inlineSuggest.jump';
const hideInlineCompletionId = 'editor.action.inlineSuggest.hide';
const toggleShowCollapsedId = 'editor.action.inlineSuggest.toggleShowCollapsed';

export { hideInlineCompletionId, inlineSuggestCommitId, jumpToNextInlineEditId, showNextInlineSuggestionActionId, showPreviousInlineSuggestionActionId, toggleShowCollapsedId };
